import { Icon } from "@opendash/icons";
import { Button, Table, Tag, Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { SIV_DeliveryNotes } from "../../../parsegenerated";

type Props = {
  deliveryNotes: SIV_DeliveryNotes[];
  loading?: boolean;
  onViewDetails?: (note: SIV_DeliveryNotes) => void;
};

export const DeliveryNotesTable = observer((props: Props) => {
  const { deliveryNotes, loading, onViewDetails } = props;

  const columns: ColumnType<SIV_DeliveryNotes>[] = [
    {
      title: "Nr.",
      dataIndex: "no",
      key: "no",
      sorter: (a, b) => a.no.localeCompare(b.no),
    },
    {
      title: "Datum",
      dataIndex: "date",
      key: "date",
      render: (date: Date) => (date ? dayjs(date).format("DD.MM.YYYY") : "-"),
      sorter: (a, b) => {
        if (!a.date || !b.date) return 0;
        return dayjs(a.date).valueOf() - dayjs(b.date).valueOf();
      },
    },
    {
      title: "Lieferdatum",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      render: (date: Date) => (date ? dayjs(date).format("DD.MM.YYYY") : "-"),
    },
    {
      title: "Transportart",
      dataIndex: "transportType",
      key: "transportType",
      render: (val: string) =>
        val ? (
          <Tag color="blue">
            <Icon icon="fa:truck" /> {val}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Betrieb",
      dataIndex: "facility",
      key: "facility",
      render: (val: string) => val || "-",
    },
    {
      title: "Transporteur",
      dataIndex: "transportedBy",
      key: "transportedBy",
      ellipsis: true,
      render: (val: string) => val || "-",
    },
    {
      title: "Kennzeichen",
      dataIndex: "licensePlate",
      key: "licensePlate",
      render: (val: string) => val || "-",
    },
    {
      title: "Aktionen",
      key: "actions",
      width: 80,
      render: (_, record) =>
        onViewDetails && (
          <Tooltip title="Details anzeigen">
            <Button
              size="small"
              icon={<Icon icon="fa:list" />}
              onClick={() => onViewDetails(record)}
            />
          </Tooltip>
        ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={deliveryNotes}
      loading={loading}
      rowKey={(record) => record.id!}
      size="small"
      pagination={{ pageSize: 10 }}
    />
  );
});
